import PropTypes from 'prop-types';
import React from 'react';
import { BounceLoader } from 'react-spinners';
import './Loader.css';

var Loader = function Loader(_ref) {
  var loading = _ref.loading,
      withOverlay = _ref.withOverlay;

  if (!withOverlay) {
    return React.createElement('div', {
      className: 'Loader'
    }, React.createElement(BounceLoader, {
      color: '#00b2a9',
      loading: loading
    }));
  }

  return loading && React.createElement('div', {
    className: 'Loader-overlay'
  }, React.createElement('div', {
    className: 'Loader'
  }, React.createElement(BounceLoader, {
    color: '#00b2a9',
    loading: loading
  })));
};

Loader.propTypes = {
  loading: PropTypes.bool.isRequired
};
Loader.defaultProps = {
  loading: true,
  withOverlay: false
};
export default Loader;